import { DropdownFilter, FilterConfig, ItemFilter } from '../model/filter';

export const getCurrentFilterLabel = <T>(key: string, options: ItemFilter<T>[]) => {
    const localStorageValue  = Number.parseInt(localStorage.getItem(key) || '');
    return options[localStorageValue ]?.label || '';
};

export const getCurrentFiltersCombinationLabel = <T>(key: string, dropdownList: DropdownFilter<T>[], filterIndex: number) => {
    const localStorageValue  = JSON.parse(localStorage.getItem(key) || '[]');
    return dropdownList[filterIndex].options[localStorageValue [filterIndex]?.optionSelectedIndex]?.label || '';
};

export const getIpFiltersDisplay = (hasSupport: boolean, filtersConfig: FilterConfig<any>, removeDropdownList = false) => {
    if (!hasSupport && filtersConfig.dropdownList && !removeDropdownList) {
        return {
            ...filtersConfig,
            dropdownList: filtersConfig.dropdownList.filter(_ => _.name !== 'IP Type')
        };
    }
    if (!hasSupport && filtersConfig.dropdownList && removeDropdownList) {
        return {
            searchBox: filtersConfig.searchBox,
            multipleDropdownList: filtersConfig.multipleDropdownList
        };
    }
    return filtersConfig;
};